import axiosClient from './axiosClient';

export const bankAccountService = {
    // Get list of banks (from Monnify via backend)
    getBanks: async () => {
        const { data } = await axiosClient.get(`/bank-accounts/banks`);
        return data.data;
    },

    // Verify NUBAN account number
    verifyAccount: async ({ accountNumber, bankCode }) => {
        const { data } = await axiosClient.post(`/bank-accounts/verify`, { accountNumber, bankCode });
        return data.data;
    },

    // Get all saved bank accounts
    getAccounts: async (userId) => {
        const response = await axiosClient.get('/bank-accounts', {
            params: { userId }
        });
        return response.data.data;
    },

    addAccount: async (data) => {
        const response = await axiosClient.post('/bank-accounts', data);
        return response.data.data;
    },

    deleteAccount: async (id, userId) => {
        const response = await axiosClient.delete(`/bank-accounts/${id}`, {
            params: { userId }
        });
        return response.data;
    },

    setDefaultAccount: async (id, userId) => {
        const response = await axiosClient.patch(`/bank-accounts/${id}/default`, { userId });
        return response.data;
    }
};
